var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-32-flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-32-flag",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_golf-flag_3675351",
    transform: "translate(10.000000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8204762,6.76928571 L1.96857143,2.76095238 L1.96857143,11.257381 L12.8204762,7.24904762 C13.0433333,7.16547619 13.0433333,6.8497619 12.8204762,6.76928571 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00261905,0.993571429 C2.00261905,0.442619048 1.55690476,0 1.00904762,0 C0.458095238,0 0.0154761905,0.445714286 0.0154761905,0.993571429 C0.0154761905,1.35880952 0.213571429,1.67142857 0.50452381,1.8447619 L0.50452381,27.3495238 C0.50452381,27.6280952 0.73047619,27.8571429 1.01214286,27.8571429 C1.29380952,27.8571429 1.5197619,27.6311905 1.5197619,27.3495238 L1.5197619,1.8447619 C1.80452381,1.67452381 2.00261905,1.35880952 2.00261905,0.993571429 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.848efec0522707d4395da44b2816dd8e.svg";
export { ForwardRef as ReactComponent };